import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ContentProvider } from "@/components/Editable";
import Home from "@/pages/Home";
import AnimalProfile from "@/pages/AnimalProfile";
import SpotterLog from "@/pages/SpotterLog";
import BigfootHistory from "@/pages/BigfootHistory";
import About from "@/pages/About";
import Layout from "@/components/Layout";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ContentProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/species/:id" element={<AnimalProfile />} />
              <Route path="/spotter-log" element={<SpotterLog />} />
              <Route path="/bigfoot-history" element={<BigfootHistory />} />
              <Route path="/about" element={<About />} />
            </Routes>
          </Layout>
        </ContentProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FAF8F5",
            border: "1px solid #D1C9B8",
            color: "#2E362F",
            fontFamily: "Manrope, sans-serif",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

export default App;
